import React from 'react';

const DeletePitches = ({
  modalInfo,
  handleCloseModal,
  handleDeletePitches
}) => {
  return (
    <div className="delete-modal-content">
      <p>Delete Selected Pitches?</p>
      <div className="delete-modal-buttons">
        <button
          className="btn btn--secondary-outline delete-modal-button"
          onClick={() => handleDeletePitches(modalInfo)}
        >
          Delete
        </button>
        <button
          className="btn btn--primary-outline delete-modal-button"
          onClick={handleCloseModal}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeletePitches;
